import { render, staticRenderFns } from "./TianyiAutoUploadConfig.vue?vue&type=template&id=fedc0c7a&scoped=true"
import script from "./TianyiAutoUploadConfig.vue?vue&type=script&lang=js"
export * from "./TianyiAutoUploadConfig.vue?vue&type=script&lang=js"
import style0 from "./TianyiAutoUploadConfig.vue?vue&type=style&index=0&id=fedc0c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc0c7a",
  null
  
)

export default component.exports